import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountUsersResponse } from './models/account-users';

@Injectable()
export class AccountUsersRepository {
  private readonly apiBase = '/api/identity/v1';

  constructor(private http: HttpClient) {}

  getAccountUsers(skip: number, take: number) {
    return this.http.get<AccountUsersResponse>(`${this.apiBase}/accounts/current/users?skip=${skip}&take=${take}`);
  }
}
